import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { GTMService } from '@services';

import { PeriodService } from '../../services/period.service';
import { ScheduleService } from '../../services/schedule.service';

@Component({
  selector: 'app-select-days-dialog',
  templateUrl: './select-days-dialog.component.html',
  styleUrls: ['./select-days-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectDaysDialogComponent implements OnInit {
  days: string[];
  daysSelection: { id: number; day: string; checked: boolean }[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectDaysDialogComponent>,
    private periodService: PeriodService,
    private scheduleService: ScheduleService,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.initData();
  }

  initData(): void {
    this.scheduleService.days.forEach((day, id) => {
      this.daysSelection.push({
        id,
        day,
        checked: false,
      });
    });
    this.days = this.scheduleService.days;
  }

  canContinue(): boolean {
    return !!this.daysSelection.find((day) => day.checked);
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onContinue(): void {
    this.dialogRef.close({ action: 'continue' });
    const dayIds = this.daysSelection.filter((day) => day.checked).map((day) => day.id);
    this.periodService.multipleDaysSelection$.next(dayIds);
  }

  trackDay(): void {
    this.gtmService.track('onSelect', 'Day', 'editSchedule');
  }
}
